module.exports = __webpack_public_path__ + "img/wxc-img.20229aa0.jpg";